import { CustomGrid } from '@/components/layout/grid'
import { chakra, Flex, GridItem, GridItemProps } from '@chakra-ui/react'
import { ComponentProps } from '@/baseComponents'

import { RichTextComponent } from '@/components/molecules/richTextComponent'
import { ImageTextAlignment, MediaTypes } from '@/types/enums'
import { MediaDataTypes } from '@/components/atoms/media/MediaData'
import { renderMedia } from '@/utils/renderMediaComponent'

export interface ImageWithTextProps extends ComponentProps {
  title: string
  intro: string
  markup: string
  mediaData?: MediaDataTypes
  alignment: ImageTextAlignment
}

/**
 * Represents a Introduction component
 * @param richTextProps - Props for rendering a title with richtext.
 * @param buttonProps - Props for rendering a button
 * @returns Introduction
 */
export default chakra(ImageWithText)
function ImageWithText({
  title,
  intro,
  markup,
  mediaData,
  alignment = ImageTextAlignment.Left,
  theme = 'brand',
}: ImageWithTextProps) {
  let layoutProps: {
    text: Partial<GridItemProps>
    media: Partial<GridItemProps>
  }

  layoutProps = {
    text: {
      colStart: { base: 0, lg: alignment === ImageTextAlignment.Left ? 1 : 8 },
      colSpan: { base: 12, lg: 5 },
      order: { base: 1, lg: alignment === ImageTextAlignment.Left ? 1 : 2 },
    },
    media: {
      colSpan: { base: 12, lg: 6 },
      colStart: { base: 0, lg: alignment === ImageTextAlignment.Left ? 7 : 1 },
      order: { base: 2, md: alignment === ImageTextAlignment.Left ? 2 : 1 },
    },
  }

  return (
    <CustomGrid gap={6}>
      <GridItem {...layoutProps.text}>
        <Flex
          flexDirection='column'
          height='full'
          justifyContent='space-between'
          gap={{ base: 4, md: '' }}
        >
          <RichTextComponent
            title={title}
            titleProps={{ fontSize: ['2rem', '3rem'] }}
          />
          <RichTextComponent
            subTitle={intro}
            subTitleProps={{
              fontSize: ['1.25rem', '1.5rem'],
              lineHeight: '1.5',
            }}
            markup={markup}
          />
        </Flex>
      </GridItem>
      <GridItem
        {...layoutProps.media}
        maxHeight={{ base: '25rem', md: '43.75rem', lg: '56.25rem' }}
      >
        {mediaData && renderMedia(mediaData, { base: 'square' }, { base: 0.7 })}
      </GridItem>
    </CustomGrid>
  )
}
